export function parseOsFamily(ua: string): string {
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Android/.test(ua)) return 'Android';
  return 'Unknown';
}

export async function parseOsVersion(ua: string): Promise<string> {
  const iosMatch = ua.match(/(?:iPhone |CPU )OS (\d+[_\.]\d+[_\.]?\d*)/);
  const androidMatch = ua.match(/Android (\d+\.?\d*\.?\d*)/);

  const isSafariIOS = /iPhone|iPad|iPod/.test(ua) && /Safari\//.test(ua) && !/CriOS|Chrome|Chromium/.test(ua);
  const safariVersionMatch = ua.match(/Version\/(\d+\.?\d*\.?\d*)/);

  if (iosMatch) {
    let osVersion = iosMatch[1].replace(/_/g, '.');
    if (isSafariIOS && safariVersionMatch) {
      osVersion = safariVersionMatch[1];
    }
    return osVersion;
  }

  if (androidMatch) {
    let osVersion = androidMatch[1];
    if ((navigator as any).userAgentData) {
      try {
        const highEntropyValues = await Promise.race([
          (navigator as any).userAgentData.getHighEntropyValues(['platformVersion']),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Timed out')), 2000)),
        ]);
        if (highEntropyValues.platformVersion) {
          osVersion = highEntropyValues.platformVersion;
        }
      } catch (err) {
        console.error('Failed to get high entropy values', err);
      }
    }
    return osVersion;
  }

  return 'Unknown';
}

export function toMajorMinor(version: string): string {
  const parts = version.split('.');
  if (parts.length >= 2) return `${parts[0]}.${parts[1]}`;
  return `${parts[0] || '0'}.0`;
}

export function detectIsTablet(ua: string): boolean {
  return (
    /iPad/.test(ua) ||
    ((navigator as any).platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    (/Android/.test(ua) && !/Mobile/.test(ua))
  );
}

export function detectNotch(): boolean {
  const div = document.createElement('div');
  div.style.paddingTop = 'env(safe-area-inset-top)';
  document.body.appendChild(div);
  const safeArea = parseInt(getComputedStyle(div).paddingTop, 10) || 0;
  document.body.removeChild(div);

  if (safeArea > 20) return true;

  const w = screen.width;
  const h = screen.height;
  const notchScreens: [number, number][] = [
    [375, 812],
    [414, 896],
    [390, 844],
    [428, 926],
    [393, 852],
    [430, 932],
    [402, 874],
    [440, 956],
  ];

  return notchScreens.some(([nw, nh]) => (w === nw && h === nh) || (w === nh && h === nw));
}

export function detectFontScale(): number {
  const testEl = document.createElement('div');
  testEl.style.cssText = 'font-size:16px;position:absolute;visibility:hidden;';
  testEl.textContent = 'Test';
  document.body.appendChild(testEl);
  const actualSize = parseFloat(getComputedStyle(testEl).fontSize);
  document.body.removeChild(testEl);
  return actualSize / 16;
}



// WEBPACK FOOTER //
// ./ts/app/shared/device-fingerprint.helpers.ts